module.exports = __webpack_public_path__ + "img/9788972758372.a349818b.jpg";